import { FormEvent, useRef } from "react";
import { useSystemInfo } from "../hooks/useTromanService";
import { ButtonVariants, Icon, Icons } from "./Buttons";

declare module 'react' {
  interface InputHTMLAttributes<T> {
    webkitdirectory?: string;
  }
}

export interface IFileInputButtonProperties {
    onInput: (files: FileList) => void;
    text?: string;
    variant?: ButtonVariants;
    icon?: Icons;
    folder?: boolean;
    className?: string;
}

export const FileInputButton = (props: IFileInputButtonProperties) => {
    const systemInfo = useSystemInfo();
    const ref = useRef<HTMLInputElement>(null);

    if (!systemInfo) {
        return;
    }

    const handleInput = (evt: FormEvent<HTMLInputElement>) => {
        const files = (evt.target as HTMLInputElement).files;
        if (files != null) {
            props.onInput(files);
            (evt.target as HTMLInputElement).value = '';
        }
    };

    return (
        <label className={`btn ${props.variant || ButtonVariants.Default} fileButton ${props.className || ''}`}>
            { props.icon && <Icon icon={props.icon}/> }
            { props.text && <span style={{marginLeft: '3px'}}>{props.text}</span> }
            <input ref={ref} style={{display: 'none'}} type="file" webkitdirectory={props.folder?"":undefined} hidden={true} multiple={true} accept={systemInfo.AttachmentExtensionsAccept} onInput={handleInput} />
        </label>
    );
};